import { HttpResponse } from '@angular/common/http';
import { CommandHistoryService } from '@app/features/editeur/services/command-history.service';
import { ObjetMaquetteDetail } from '@pcscol/odf-api-v1-angular';
import { Observable, Subscription } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';
import { ObjetMaquetteService } from '../../services/objet-maquette.service';
import { ObjetMaquette } from '../objet-maquette.model';
import { CommandEvents } from './command-events';

/**
 * Pattern Commande do/undo
 */
export interface Command<E> {
    do(): Observable<E>;
    destroy(): void;
}

export interface UndoCommand<E> extends Command<E> {
    undo(): Observable<unknown>;
}
export class HistoryDecoratorCommand<E> implements Command<E> {
    constructor(private command: Command<E>, private historyService: CommandHistoryService) {}

    do(): Observable<E> {
        return this.command.do().pipe(
            tap(() => {
                this.historyService.push(this.command);
            })
        );
    }

    destroy(): void {}
}

export abstract class ObjetMaquetteUndoCommand<E> implements Command<E> {
    private subcription: Subscription;

    constructor(
        protected codeStructure: string,
        protected id: string,
        protected version: string,
        protected events: CommandEvents,
        protected objetMaquetteService: ObjetMaquetteService
    ) {
        this.subcription = events.objetMaquetteModifie$
            .pipe(
                filter(om => om?.id == id),
                map(om => om as ObjetMaquette)
            )
            .subscribe(om => {
                if (Number(this.version) < Number(om.version)) {
                    this.version = om.version;
                }
            });
    }

    abstract do(): Observable<E>;
    abstract undo(): Observable<E>;

    protected convertToObjetMaquette(response: HttpResponse<ObjetMaquetteDetail>): ObjetMaquette {
        return toObjetMaquette(response);
    }

    destroy(): void {
        this.subcription.unsubscribe();
    }
}

export function toObjetMaquette(response: HttpResponse<ObjetMaquetteDetail>): ObjetMaquette {
    return {
        ...(response.body! as Required<ObjetMaquetteDetail>),
        version: JSON.parse(response.headers.get('ETag')!),
        hasSomeContextWithPIA: response.body?.contextes?.some(c => !!c.pointInscriptionAdministrative) ?? false
    };
}
